import { render, staticRenderFns } from "./Cours.vue?vue&type=template&id=f2d1593c"
import script from "./Cours.vue?vue&type=script&lang=js"
export * from "./Cours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports